<mable-banner
  *ngIf="calculatedRate || canUseExceededCapRates"
  category="headed-banner"
  icon="information-circle"
  [heading]="
    canUseExceededCapRates ? 'Rate exceeds NDIS price limit for 1 or more services' : 'Rate exceeds NDIS price limit'
  "
  [canClose]="false"
>
  <ng-container class="content">
    <ng-container *ngIf="canUseExceededCapRates">
      <p class="ion-padding-top">
        <strong
          >Rates exceeding NDIS price limits will be rejected by your client's plan manager and will not be
          paid.</strong
        >
      </p>
      <p>
        Reduce this rate to align with NDIS price limits, or move the affected services to a new service group with
        different rates.
      </p>
      <p>The maximum agreed rates you can charge via Mable are:</p>
    </ng-container>

    <p *ngIf="!canUseExceededCapRates">
      Exceeding an NDIS price limit will result in your support hours being rejected by an NDIS plan manager.
      <strong>Rejected hours will not be paid.</strong>
    </p>
    <p *ngIf="!canUseExceededCapRates">
      The maximum agreed rate it is possible to charge via Mable is
      <strong>{{ calculatedRate.capRate | currency: 'AUD' : '$' }} per hour</strong>, inclusive of Mable’s client fee.
    </p>

    <ng-container
      class="content"
      *ngIf="canUseExceededCapRates; else calculatedRatePriceLimitTemplate"
    >
      <div
        class="ion-margin-top padding-top"
        *ngFor="let exceededCapRateService of exceededCapRates"
      >
        <p class="ion-no-margin">
          <strong>NDIS service category:</strong> {{ exceededCapRateService.serviceCategoryName }}
        </p>
        <p class="ion-no-margin"><strong>Day/time:</strong> {{ exceededCapRateService.timeblock | timeblockName }}</p>
        <p class="ion-no-margin"><strong>State:</strong> {{ exceededCapRateService.supportLocation }}</p>
        <p class="ion-no-margin">
          <strong>Price limit:</strong> {{ exceededCapRateService.capRate | currency: 'AUD' : '$' }} per hour
        </p>

        <mable-button
          *ngIf="canMoveServiceToNewGroup"
          class="ion-no-padding"
          icon="swap-horizontal"
          category="header-detailed"
          (onClick)="onMoveServiceClick(exceededCapRateService.serviceId)"
        >
          Move to new service group
        </mable-button>
        <hr />
      </div>
      <!-- Additional information for User's with (01) Assistance with personal domestic activities service -->
      <ng-container *ngIf="hasAssistanceWithPersonalDomesticActivitiesService">
        <p class="padding-top">
          <strong> Note: </strong>
          (01) Assistance with Personal Domestic Activities has no weekend, overnight or public holiday price limits-
          just one price limit that applies to all times of day and days of week.
        </p>
        <ul class="bullet-list">
          <li>
            If your client requires more general assistance, Personal care/and or Daily Living Assistance may be the
            more appropriate service to select. This service has overnight, weekend and public holiday rates.
          </li>
          <li>
            Follow the link below to learn the difference between Domestic Assistance, and Personal care/and or Daily
            Living Assistance.
          </li>
        </ul>
      </ng-container>
      <ng-container *ngTemplateOutlet="priceLimitMoreInfo"> </ng-container>
      <hr />
    </ng-container>

    <ng-template #editRequestServicesandRates>
      <div class="update-rate-or-service">
        <p class="no-margin-bottom">Selected the wrong date or time?</p>
        <mable-button
          category="link"
          (onClick)="onEditClick()"
          class="banner-link ion-no-padding ion-no-margin"
        >
          Edit rate details
        </mable-button>

        <p class="no-margin-bottom">Selected the wrong service category?</p>
        <mable-button
          category="link"
          (onClick)="onEditServicesClick()"
          class="banner-link ion-no-padding ion-no-margin"
        >
          Edit services
        </mable-button>

        <p class="no-margin-bottom">Want to request a service category that's not in the list?</p>
        <mable-button
          category="link"
          (onClick)="onRequestServiceClick()"
          class="banner-link ion-no-padding ion-no-margin"
        >
          Request a service
        </mable-button>
      </div>
    </ng-template>

    <ng-template #priceLimitMoreInfo>
      <p>
        On Mable, independent support workers negotiate their rates
        <strong>and typically charge less than maximum NDIS price limits</strong>, to meet client expectations.
      </p>
      <mable-button
        category="link"
        class="banner-link ion-no-padding ion-no-margin"
        (onClick)="openWhyThereArePriceLimitsLink()"
        >More info about NDIS price limits
      </mable-button>
    </ng-template>

    <!-- Legacy price limit display -->
    <ng-template #calculatedRatePriceLimitTemplate>
      <div class="alert-accordion">
        <app-collapsible
          class="alt-color no-line long-heading"
          title="What’s the max I can charge within this price limit?"
          headingType="h4"
          headingStyle="h5"
          [isPanelExpanded]="false"
          [noPadding]="true"
          (expand)="
            triggerSegmentEvent(EventTrackingEnum.SP_NDIS_PRICE_LIMIT_ALERT_MAX_AGREED_RATE_EXPLAINER_ACCORDION_OPENED)
          "
        >
          <ng-container class="content">
            <ul class="bullet-list">
              <li>{{ calculatedRate.serviceCategoryName }}</li>
              <li>{{ calculatedRate.priceLimitAlertType }}</li>
              <li>{{ calculatedRate.supportLocation }} Non-remote</li>
            </ul>
          </ng-container>
        </app-collapsible>
      </div>
      <ng-container *ngTemplateOutlet="editRequestServicesandRates"> </ng-container>
      <ng-container *ngTemplateOutlet="priceLimitMoreInfo"> </ng-container>
    </ng-template>

    <app-collapsible
      class="alt-color no-line long-heading"
      [title]="canUseExceededCapRates ? 'FAQ: NDIS price limits' : 'How do I check NDIS price limits?'"
      headingType="h4"
      headingStyle="h5"
      [isPanelExpanded]="false"
      [noPadding]="true"
    >
      <ng-container class="content">
        <div>
          <ol>
            <li>Look up NDIS price limits, by service type, time and location.</li>
            <li>Include Mable’s client platform fee by calculating:</li>
          </ol>
          <p class="no-margin-bottom">
            NDIS price limit ÷ {{ legacyAgreement ? 1.05 : 1.0795 }} = Max agreed rate you can charge.
          </p>
          <mable-button
            category="link"
            class="banner-link ion-no-padding ion-no-margin"
            (onClick)="openViewNdisPriceLimits()"
            >View NDIS price limits
          </mable-button>

          <ng-container *ngIf="canUseExceededCapRates">
            <ng-container *ngTemplateOutlet="editRequestServicesandRates"> </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </app-collapsible>
  </ng-container>
</mable-banner>
